import React, { createContext, useContext, useState } from "react";
import socket from "services/SocketService";
import { notifySuccess, notifyError } from "utils/toast";

const ChatStatusContext = createContext();

export const ChatStatusProvider = ({ children }) => {
  const [isOnline, setIsOnline] = useState(
    sessionStorage.getItem("isOnline") === "true"
  );

  const [statusBusy, setStatusBusy] = useState(false);

  const setOnlineStatus = (online) =>
    new Promise((resolve) => {
      const adminInfo = localStorage.getItem("adminInfo")
        ? JSON.parse(localStorage.getItem("adminInfo"))
        : null;

      const id_employee = adminInfo?.id || 0;

      if (!id_employee) {
        resolve({
          status: false,
          message: "Employee information not found.",
        });
        return;
      }

      const send = () => {
        const onReply = (res) => {
          clearTimeout(timer);
          socket.off("online_status_updated", onReply);
          resolve(res);
        };

        const timer = setTimeout(() => {
          socket.off("online_status_updated", onReply);

          resolve({
            status: false,
            message: "Chat server did not respond. Please try again.",
          });
        }, 8000);

        socket.on("online_status_updated", onReply);

        socket.emit("update_online_status", {
          employeeId: id_employee,
          isOnline: online,
        });
      };

      if (socket.connected) {
        send();
      } else {
        socket.once("connect", () => {
          setTimeout(send, 300);
        });

        socket.connect();
      }
    });

  const applyOnlineStatus = async (online) => {
    if (statusBusy) {
      return;
    }

    setStatusBusy(true);

    try {
      const res = await setOnlineStatus(online);

      if (res?.status) {
        const newStatus = Boolean(res.isOnline);

        sessionStorage.setItem("isOnline", String(newStatus));
        setIsOnline(newStatus);

        notifySuccess(
          res.message ||
            (newStatus
              ? "You are now online."
              : "You are now offline.")
        );
      } else {
        notifyError(
          res?.message || "Could not change online status."
        );
      }
    } catch (error) {
      notifyError("Could not change online status.");
    } finally {
      setStatusBusy(false);
    }
  };

  const goOnline = () => {
    return applyOnlineStatus(true);
  };

  const goOffline = () => {
    return applyOnlineStatus(false);
  };

  return (
    <ChatStatusContext.Provider
      value={{
        isOnline,
        setIsOnline,
        statusBusy,
        setStatusBusy,
        setOnlineStatus,
        applyOnlineStatus,
        goOnline,
        goOffline,
      }}
    >
      {children}
    </ChatStatusContext.Provider>
  );
};

export const useChatStatus = () => {
  return useContext(ChatStatusContext);
};

